import { Link } from "react-router";
import "./chartBox.css";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

type Props = {
  color: string;
  icon: string;
  title: string;
  dataKey: string;
  number: number | string;
  percentage: number;
  chartData: object[];
};

function numberWithCommas (nStr) {
  nStr += '';
    let x = nStr.split('.');
    let x1 = x[0];
    let x2 = x.length > 1 ? '.' + x[1] : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    }
    x = x1 + x2;
    if(x.substr(0,1) === '.'){
        x = '0' + x;
    }
    return x;
};


const ChartBox = (props: Props) => {
  return (
    <div className="chartBox">
      <div className="boxInfo">
        <div className="title">
          {/* <img src={props.icon} alt="" /> */}
          <span>{props.title}</span>
        </div>
        <h1 style={{ color: props.color }}>{numberWithCommas(props.number)}</h1>
        <div className="texts">
          <span
            className="percentage"
            // style={{ color: props.percentage < 0 ? "tomato" : "limegreen" }}
            
          >
            {numberWithCommas(props.percentage)}
          </span>
          <span className="duration">last period</span>
        </div>
        {/* <Link to="#" style={{ color: props.color }}>
          View all
        </Link> */}
      </div>
      <div className="chartInfo">
        <div className="chart">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart 
              data={props.chartData} 
              // width={200} height={100}
              // margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
            >
              <XAxis dataKey={props.xaxisKey} tick={{ fill: '#ffffff' }} tickLine={{ stroke: '#688394' }}
                axisLine={{ stroke: '#EAF0F4' }} 
                style={{
                  fontSize: '10px',
                  // fontFamily: 'Times New Roman',
                }}

              />
              <YAxis  type="number" scale="auto" tick={{ fill: '#ffffff' }} tickLine={{ stroke: '#688394' }}
                      axisLine={{ stroke: '#EAF0F4' }} 
                      style={{
                        fontSize: '10px',
                        // fontFamily: 'Times New Roman',
                      }}
                      domain={['dataMin', 'auto']}
                      // includeHidden 
              />
            <Tooltip
              contentStyle={{ background: "#2a3447", borderRadius: "5px" }}
              // labelStyle={{ display: "none" }}
              cursor={{fill:"none"}}
            />
              <Line
                type="monotone"
                dataKey={props.dataKey}
                stroke={props.color}
                strokeWidth={2}
                dot={false}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default ChartBox;
